'use strict';

const DiagramActionCreator = require('system/domain/action/diagram');
const DiagramStore = require('system/domain/repository/diagram');
const ItemView = require('system/ui/view/diagram/item');
const ItemEditView = require('system/ui/view/diagram/item-edit');
const DirectoryView = require('system/ui/view/diagram/directory');
const DirectoryEditView = require('system/ui/view/diagram/directory-edit');
const DropZoneTemplate = require('system/ui/template/diagram/dropzone.hbs');
const Mn = require('backbone.marionette');

const DropView = Mn.View.extend({
    template: DropZoneTemplate,
    className: 'diagram-dropzone',
    onRender: function() {
        this.$el.droppable({
            greedy: true,
            classes: {
                'ui-droppable-hover': 'is-highlighted',
                'ui-droppable-active': 'is-droppable'
            },
            drop: (event, ui) => {
                const view = $(ui.draggable).data('backbone-view');
                if(!view) {
                    return;
                }

                const m = view.model;
                if(m.get('directory')) {
                    this.onDropDirectory(m);
                } else {
                    this.onDropDiagram(m);
                }
            }
        });
    },

    onDropDiagram: function(diagram) {
        var directory = null;
        this.collection.chain()
            .filter(function(m) {
                return m.get('directory');
            })
            .each(function(d) {
                var diagrams = d.get('diagrams');
                if(_.contains(diagrams, diagram.id)) {
                    directory = d;
                    d.set({diagrams: _.without(diagrams, diagram.id)});
                }
            });

        if(directory){
            var j = directory.toJSON();
            DiagramActionCreator.updateDirectory(
                this.getOption('context').projectId,
                j.id,
                j
            );
        }
    },

    onDropDirectory: function(directory) {
        directory.set({parentDirectory: null});
        DiagramActionCreator.updateDirectory(
            this.getOption('context').projectId,
            directory.id,
            {
                parentDirectory: null
            }
        );
    }
});

module.exports = Mn.CollectionView.extend({
    editMode: false,
    className: 'list',
    childView: function(child) {
        if(this.getOption('editMode')) {
            if(child.get('directory')) {
                return DirectoryEditView;
            } else {
                return ItemEditView;
            }
        } else {
            if(child.get('directory')) {
                return DirectoryView;
            } else {
                return ItemView;
            }
        }
    },
    childViewOptions: function() {
        return {
            context: this._context,
            diagram: this.getOption('diagram'),
            isMember: this._isMember,
            collection: this.collection,
            childView: this.childView,
            viewComparator: this.viewComparator,
            editMode: this.getOption('editMode'),
            showDescription: this.getOption('showDescription')
        };
    },

    initialize: function(params) {
        this._group = params.group;
        this._context = params.context;
        this._isMember = this._group.get('isAdmin') ||
            this._group.get('isMember');
        this._diagrams = this.collection;
        this._directories = DiagramStore.getDiagramDirectories(
            {context: {projectId: this._context.projectId}}
        );
        this.collection = this.collection.clone();
        this.collection.add(this._directories.models, {trigger: false});

        this.listenTo(this._diagrams, 'fetch', function(){
            this.collection.add(this._diagrams.models, {trigger: false});
            this.render();
        });
        this.listenTo(this._diagrams, 'add', function(m){
            this.collection.add(m);
        });
        this.listenTo(this._diagrams, 'remove', function(m){
            this.collection.remove(m);
        });
        this.listenTo(this._diagrams, 'change:edit', this.render);
        this.listenTo(this._directories, 'fetch', function(){
            this.collection.add(this._directories.models, {trigger: false});
            this.render();
        });
        this.listenTo(this._directories, 'add', function(m){
            this.collection.add(m);
        });
        this.listenTo(this._directories, 'remove', function(m){
            this.collection.remove(m);
        });
        this.listenTo(this._directories, 'change:edit', this.render);
        this.listenTo(this._directories, 'change:diagrams', this.render);
        this.listenTo(this._directories, 'change:parentDirectory', this.render);
        this.listenTo(this.collection, 'resort', this.render);
        this.listenTo(this.collection, 'destroy', function(model) {
            this.collection.remove(model);
        });
    },

    onRender: function() {
        $.material.init();

        const editMode = this.getOption('editMode');
        if(editMode && !this.dropZone) {
            this.dropZone = new DropView({
                context: this._context,
                collection: this.collection
            });
            this.$el.prepend((this.dropZone.render().el));
        }
    },

    onDomRefresh: function() {
        $.material.init();
    },

    viewComparator: function(child) {
        // 作りたてのものは一番前
        if(child.get('creating')) {
            return '';
        }
        // directory を後ろに持ってくる
        return child.get('directory') ? '\uFFFF' : '' +
            child.get('name');
    },

    filter: function(child) {
        if(child.isDeleted()) {
            return false;
        }
        if(child.get('directory')){
            return !child.get('parentDirectory');
        }

        this._directoryDiagrams = this.collection.chain()
            .filter(function(m) {
                return m.get('directory');
            })
            .map(function(d) {
                return d.get('diagrams');
            })
            .flatten()
            .value();
        if(_.contains(this._directoryDiagrams, child.id)) {
            return false;
        }
        return true;
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/diagram/list.js